import React from 'react';

const SmallContainer = props => {
  return (
    <div className="smallContainer">
      <table>
        <thead>
          <tr>
            <th colSpan="2">&nbsp;</th>
            <th>&nbsp;</th>
            <th>&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="importantData">{props.text}</td>
            <td>{props.value}</td>
            <td className="percent">{props.percent}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default SmallContainer;
